var React = require('react');

function Change (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"44","height":"44","rx":"6","key":0}),React.createElement("path",{"d":"M34.0229 27.2189C34.5237 27.6192 34.5237 28.3808 34.0229 28.7811L26.8744 34.4957C26.2196 35.0191 25.25 34.5529 25.25 33.7146L25.25 22.2854C25.25 21.4471 26.2196 20.9809 26.8744 21.5043L34.0229 27.2189Z","fill":"white","key":1}),React.createElement("path",{"d":"M9 28H26","stroke":"white","strokeWidth":"2","key":2}),React.createElement("path",{"d":"M9.97709 17.7811C9.47631 17.3808 9.47631 16.6192 9.97709 16.2189L17.1256 10.5043C17.7804 9.98087 18.75 10.4471 18.75 11.2854L18.75 22.7146C18.75 23.5529 17.7804 24.0191 17.1256 23.4957L9.97709 17.7811Z","fill":"white","key":3}),React.createElement("path",{"d":"M35 17L18 17","stroke":"white","strokeWidth":"2","key":4})]);
}

Change.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"#231F20"};

module.exports = Change;

Change.default = Change;
